import { useLanguage } from '@/contexts/language-context';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { PayrollDateRangeFilters } from '@/lib/api/payroll';

interface Props {
  value: PayrollDateRangeFilters;
  onChange: (next: PayrollDateRangeFilters) => void;
}

/**
 * Plain from/to date inputs — the codebase has no reusable date-range picker
 * component, and native `<input type="date">` matches the existing
 * lightweight approach used elsewhere (e.g. the jobs filter bar).
 */
export function PayrollDateFilter({ value, onChange }: Props) {
  const { t } = useLanguage();

  return (
    <div className="flex items-end gap-3">
      <div className="flex flex-col gap-1">
        <Label htmlFor="payroll-filter-from" className="text-xs text-muted-foreground">
          {t.payrollFilterFrom}
        </Label>
        <Input
          id="payroll-filter-from"
          type="date"
          value={value.from ?? ''}
          onChange={(e) => onChange({ ...value, from: e.target.value || undefined })}
          className="h-9 w-36"
          data-testid="payroll-filter-from"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Label htmlFor="payroll-filter-to" className="text-xs text-muted-foreground">
          {t.payrollFilterTo}
        </Label>
        <Input
          id="payroll-filter-to"
          type="date"
          value={value.to ?? ''}
          onChange={(e) => onChange({ ...value, to: e.target.value || undefined })}
          className="h-9 w-36"
          data-testid="payroll-filter-to"
        />
      </div>
    </div>
  );
}
